import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface HistoryState {
  historyList: string[];
}

const initialState: HistoryState = {
  historyList: [],
};

export const historySlice = createSlice({
  name: "historySlice",
  initialState,
  reducers: {
    setHistoryData: (state, action: PayloadAction<string>) => {
      state.historyList.push(action.payload);
    },
  },
});

export const { setHistoryData } = historySlice.actions;

export default historySlice.reducer;
